import { GET_USER, GET_USER_ERROR } from '../actions/Types'

const shouldFetchUser = (state=true, action) => {
    switch (action.type){
        case GET_USER:
            return true
        case GET_USER_ERROR:
            return action.payload
        default:
            return state
    }
}

export default shouldFetchUser